{
  "version": 1,
  "cloud": {
    "quality": "balanced",
    "coverage": 0.36,
    "density": 2.89,
    "shapeScale": 3.3,
    "softness": 0.115,
    "bottomFade": 0.01,
    "topFade": 0.11,
    "anvil": 0.72,
    "detailErosion": 1.29,
    "detailContrast": 3,
    "detailScale": 2.65,
    "worldScale": 3700,
    "weatherScale": 8750,
    "weatherStrength": 0.79,
    "warpScale": 3300,
    "warpStrength": 0.42,
    "baseBlend": 0.38,
    "detailBlend": 0.32,
    "boundaryFade": 0.34,
    "detailFilter": 0,
    "extinction": 0.022,
    "sunAzimuth": 225,
    "sunElevation": 18,
    "sunIntensity": 1.45,
    "sunColor": "#fff0d2",
    "cloudColor": "#dfe9ee",
    "ambientTop": "#759ab4",
    "ambientBottom": "#26394b",
    "ambientIntensity": 0.85,
    "phaseForward": 0.33,
    "phaseBackward": -0.45,
    "phaseMix": 0.93,
    "powder": 4,
    "windDirection": 15,
    "windSpeed": 0,
    "turbulenceSpeed": 0.006,
    "formationStrength": 0,
    "formationSpeed": 0,
    "roilStrength": 0,
    "roilSpeed": 0,
    "viewSteps": 74,
    "lightSteps": 10,
    "detailOctaves": 1,
    "renderScale": 0.29,
    "jitterStrength": 1,
    "animatedJitter": true,
    "earlyExit": 0.001,
    "lightDistance": 0.13,
    "shadowDistribution": 1.75,
    "debugMode": 0,
    "frozen": false,
    "label": "Balanced"
  },
  "atmosphere": {
    "quality": "balanced",
    "automaticLighting": true,
    "autoExposure": true,
    "sunAzimuth": 71,
    "sunElevation": 6,
    "turbidity": 5,
    "rayleigh": 0.38,
    "mieCoefficient": 0.0004,
    "mieDirectionalG": 0.87,
    "ozone": 0.12,
    "multipleScattering": 0.28,
    "groundAlbedo": "#26383b",
    "skyIntensity": 0.72,
    "sunIntensity": 2.34,
    "sunsetStartElevation": 25.5,
    "sunsetWarmth": 1.75,
    "sunsetBrightness": 2.6,
    "aerialDensity": 0.0005,
    "exposure": 0.69,
    "animateTime": false,
    "timeScale": 0.55
  },
  "temporal": {
    "enabled": true,
    "historyWeight": 0.21,
    "depthThreshold": 37,
    "alphaThreshold": 0.02,
    "motionRejection": 20,
    "depthSharpness": 0.075,
    "alphaSharpness": 10,
    "clampExpansion": 0.04,
    "detailBlur": 4,
    "occlusionSoftness": 3.75
  },
  "cloudShadows": {
    "enabled": true,
    "resolution": 512,
    "distance": 9800,
    "samples": 16,
    "strength": 0.71,
    "softness": 1.55,
    "density": 0.82,
    "minimumLight": 0,
    "gamma": 0.82
  },
  "adaptive": {
    "enabled": false
  },
  "resources": {
    "seed": 11,
    "baseResolution": 96,
    "detailResolution": 48
  }
}
